module.exports = __webpack_public_path__ + "static/media/buildings.999c3630.geojson";